import React from "react";
import styles from "./SectionArticles.module.css";
import { SectionTitle, Error, Loader, Article } from "../../components";
import { removeDashesAndCapitalize } from "../../utilities/dataManipulation";

const SectionArticlesUI = ({ section, articles, loading, error }) => {
  let sectionName = section === "realestate" ? "real-estate" : section;
  return (
    <div className={styles.section_articles}>
      <SectionTitle title={removeDashesAndCapitalize(sectionName)} />
      {error && <Error errorMessage={error} />}
      {loading && <Loader />}

      <div className={styles.articles_layout}>
        {articles &&
          articles.map((article) => (
            <Article
              key={article.slug}
              article={article}
              articleType="section"
            />
          ))}
      </div>
    </div>
  );
};

export default SectionArticlesUI;
